/**
 * Deli soups data
 * Represents homemade soups available at the deli
 */

const deliSoups = [
  {
    id: 1,
    name: "Chicken Noodle",
    description: "Available in: Cup • Bowl • Pint • Quart",
    category: "soups"
  },
  {
    id: 2,
    name: "Mushroom Barley",
    description: "Available in: Cup • Bowl • Pint • Quart",
    category: "soups"
  },
  {
    id: 3,
    name: "Soup of the Day",
    description: "Available in: Cup • Bowl • Pint • Quart",
    category: "soups"
  },
  {
    id: 4,
    name: "Matza Ball",
    description: "Available in: Pint • Quart only",
    category: "soups"
  },
  {
    id: 5,
    name: "Kreplach",
    description: "Available in: Pint • Quart only",
    category: "soups"
  }
];

module.exports = deliSoups;